/**
 * Stone Investment Spaces Wizard
 *
 * Stone-themed wrapper for the Royale Spaces Wizard.
 * Used for standalone pages (e.g., /spaces)
 */

'use client';

import { SpacesWizard } from '@/components/spaces';
import React from 'react';

export const StoneSpacesWizard: React.FC = () => {
  return <SpacesWizard />;
};

export default StoneSpacesWizard;
